export default __webpack_public_path__ + "static/media/per-talent.22ebe8e8.svg";